import React, { useState } from 'react';
import { toast } from 'sonner';
import { FileDown, Loader2, Quote } from 'lucide-react';
import { scaricaPdf, erroreHaccp, dataIt } from '../haccpApi';
import { VotoAnello, GIUDIZI } from './VotoAnello';
import { VociIspezione, ControlliManuali } from './VociIspezione';

const Aree = ({ aree }) => (
  <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
    {aree.map((a) => {
      const stile = a.gravi ? 'border-red-200 bg-red-50' : a.attenzione ? 'border-amber-200 bg-amber-50' : 'border-emerald-200 bg-emerald-50';
      return (
        <div key={a.area} className={`rounded-xl border p-2.5 ${stile}`} data-testid={`ispezione-area-${a.area}`}>
          <p className="text-xs font-semibold text-gray-900 leading-tight">{a.nome}</p>
          <p className="text-[11px] text-gray-600 mt-1">{a.gravi || a.attenzione ? `${a.gravi} gravi · ${a.attenzione} da controllare` : 'In ordine'}</p>
        </div>
      );
    })}
  </div>
);

export const RisultatoIspezione = ({ isp }) => {
  const [scarico, setScarico] = useState(false);
  const g = GIUDIZI[isp.giudizio];
  const pdf = async () => {
    setScarico(true);
    try { await scaricaPdf(`/ispezione/${isp.id}/fascicolo`, `Ispezione_HACCP_${isp.al}.pdf`); }
    catch (e) { toast.error(erroreHaccp(e, 'Fascicolo non disponibile')); }
    finally { setScarico(false); }
  };
  return (
    <div className="space-y-5" data-testid="ispezione-risultato">
      <div className="bg-white rounded-2xl border border-gray-200 p-4 flex flex-col sm:flex-row items-center gap-4">
        <VotoAnello voto={isp.voto} giudizio={isp.giudizio} />
        <div className="flex-1 text-center sm:text-left space-y-2">
          <span className={`inline-block px-3 py-1 rounded-full border text-sm font-bold ${g.sfondo}`} data-testid="ispezione-giudizio">{g.testo}</span>
          <p className="text-sm text-gray-700">{isp.gravi} punti gravi · {isp.attenzione} da controllare</p>
          <p className="text-xs text-gray-500">Periodo dal {dataIt(isp.dal)} al {dataIt(isp.al)} · eseguita il {dataIt(isp.creata_il)}</p>
          <button onClick={pdf} disabled={scarico} data-testid="ispezione-fascicolo-btn"
            className="h-11 px-5 rounded-full bg-gray-900 hover:bg-gray-800 text-white text-sm font-semibold inline-flex items-center gap-2 disabled:opacity-60">
            {scarico ? <Loader2 className="h-4 w-4 animate-spin" /> : <FileDown className="h-4 w-4" />}
            {scarico ? 'Preparo il fascicolo...' : 'Scarica fascicolo completo'}
          </button>
        </div>
      </div>
      {isp.commento && (
        <div className="bg-slate-50 border border-slate-200 rounded-2xl p-4" data-testid="ispezione-commento">
          <p className="flex items-center gap-2 text-xs font-bold uppercase tracking-wide text-slate-500 mb-2"><Quote className="h-4 w-4" />L'ispettore (simulato)</p>
          <p className="text-sm text-slate-800 whitespace-pre-line leading-relaxed">{isp.commento}</p>
        </div>
      )}
      <Aree aree={isp.aree} />
      <VociIspezione voci={isp.voci} aree={isp.aree} />
      <div className="space-y-2">
        <h4 className="text-sm font-bold text-gray-900">Da controllare a mano (l'app non lo vede)</h4>
        <ControlliManuali elenco={isp.da_verificare || []} />
      </div>
      <p className="text-[11px] text-gray-400">Simulazione basata sui registri dell'app: aiuta a prepararsi, non sostituisce il manuale HACCP, il consulente né il giudizio dell'ASL.</p>
    </div>
  );
};
